import { FC } from "react";

import { OAuthRedirectDesktopPageBase } from "@/pages/oauth-redirect-desktop/oauth-redirect-desktop-page-base";

export const GoogleOAuthRedirectDesktopPage: FC = () => {
  return (
    <OAuthRedirectDesktopPageBase
      deepLinkPath="google-oauth-redirect"
      logPrefix="GoogleOAuthRedirectDesktopPage"
    />
  );
};
